<template>
  <el-dialog title="分配员工" :visible.sync="visible" width="40%">
      <el-form ref="addForm" :model="data" :rules="rules" label-width="100px">
        <el-form-item label="分配员工：" prop="managerId">
          <el-select v-model="data.managerId" placeholder="请选择" clearable style="width:100%">
            <el-option
              v-for="dict in staffOptions"
              :key="dict.userId"
              :label="dict.nickName"
              :value="dict.userId"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" @click="confirm">确认</el-button>
      </span>
    </el-dialog>
</template>

<script>
import { mapState } from "vuex";
import { queryContactList, assign } from "@/api/saas/package";
import { listUserWithOutDataScope } from "@/api/system/user";
export default {
  name: "AddDialog",
  data() {
    return {
      staffOptions: [],
      visible: false,
      rules: {
        managerId: [
          { required: true, message: "请选择员工", trigger: "change" }
        ]
      },
      data: {
        managerId: null,
      },
      id: null
    };
  },
  computed: {
    ...mapState({
      currentUserId: state => state.user.userId
    })
  },
  watch: {
    visible(val) {
      if (!val) {
        this.resetForm("addForm");
      }
    }
  },
  methods: {
    open(id) {
      this.visible = true;
      this.id = id
      this.listUserWithOutDataScope()
    },
    listUserWithOutDataScope() {
      listUserWithOutDataScope().then(response => {
        this.staffOptions = response.rows;
      });
    },
    confirm() {
      this.$refs["addForm"].validate(valid => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: "加载中",
            spinner: "el-icon-loading"
          });
          assign({
            potentialContactId: this.id,
            managerId: this.data.managerId
          })
            .then(response => {
              this.visible = false;
              loading.close();
              this.$emit("success");
              this.msgSuccess("分配成功");
            })
            .catch(error => {
              loading.close();
            });
        } else {
          this.msgWarning("请检查必填项");
          return false;
        }
      });
    }
  }
};
</script>
